import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { sharedRouting, sharedRoutingProviders } from './shared.routes';
import {TranslateModule} from 'ng2-translate';

import { TooltipModule } from 'ng2-tooltip';

import { ErrorComponent } from './components/error/error.component';

import { HttpClientService } from './services/http-client.service';
import { SpinnerService } from './services/spinner.service';
import { CookieManagerService } from './services/cookie-manager.service';
import { AlertManagerService } from './services/alert-manager.service';

@NgModule({
  declarations: [
    ErrorComponent,
  ],
  imports: [
    CommonModule,
    BrowserModule,
    FormsModule,
    sharedRouting,
    TooltipModule,
    TranslateModule
  ],
  providers: [ sharedRoutingProviders, HttpClientService, SpinnerService, CookieManagerService, AlertManagerService ]
})
export class SharedModule { }



// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts